import type { AnchorHTMLAttributes } from 'react';

import { RedirectIcon } from 'app/components/pages/Hotels/RedirectIcon';

type RedirectLinkProps = {
  href: string;
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
};

export const RedirectLink = ({
  href,
  target = '_blank',
}: RedirectLinkProps) => (
  <a href={href} target={target} rel="noopener noreferrer">
    <RedirectIcon />
  </a>
);
